'use client';
import { CaseV2 } from '@/types/case';
import classNames from 'classnames';
import { LayoutContainer } from 'components/layout-container';
import { Pill } from 'components/pill';
import { Typography } from 'components/typography';
import { SurfaceContext } from 'contexts/SurfaceContext';
import { getContrastSurface } from 'helpers/getContrastSurface';
import { CSSProperties, useContext, useEffect } from 'react';
import { Author } from '../commonComponents/author/author';
import styles from './styles.module.scss';

export const CaseHero = (props: CaseV2) => {
  const surface =
    getContrastSurface(props.client.data.attributes.companyColor) === 'neutral'
      ? 'secondary'
      : 'white';
  const hasAuthor = props.capis.data.length > 0;

  const contextSurface = surface === 'white' ? 'inverted' : 'neutral';
  const surfaceContextValue = useContext(SurfaceContext);

  useEffect(() => {
    surfaceContextValue.setValue(contextSurface);

    return () => {
      surfaceContextValue.setValue('neutral');
    };
  }, [contextSurface, surfaceContextValue]);

  return (
    <section
      style={
        {
          '--bg-color': props.client.data.attributes.companyColor,
        } as CSSProperties
      }
      className={styles.sectionContainer}
    >
      <LayoutContainer size="medium" className={styles.hero}>
        <div
          className={classNames(
            styles.container,
            !hasAuthor && styles.hasNoAuthor
          )}
        >
          <div className={styles.content}>
            <Typography
              tag="h4"
              variant="heading1-sub"
              color={surface}
              style={{ opacity: 0.5 }}
            >
              {props.client.data.attributes.company}
            </Typography>
            <Typography
              tag="h1"
              variant="heading1-display-cases"
              color={surface}
            >
              {props.heroTitle ?? props.title}
            </Typography>
            <div className={styles.pills}>
              <Pill variant={surface === 'white' ? 'inverted' : 'default'}>
                {props.deliverable}
              </Pill>
              <Pill variant={surface === 'white' ? 'inverted' : 'default'}>
                {props.techStack}
              </Pill>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src={props.heroImage.data.attributes.url}
              alt={props.heroImage.data.attributes.alternativeText as string}
            />
          </div>
          {hasAuthor && (
            <Author
              className={styles.author}
              title="Powered By"
              style="fancy"
              authors={props.capis.data.map((capi) => ({
                name:
                  capi.attributes.firstName + ' ' + capi.attributes.lastName,
                image: capi.attributes.thumbnail.data.attributes.url,
              }))}
            />
          )}
        </div>
      </LayoutContainer>
    </section>
  );
};
